export default __webpack_public_path__ + "static/media/item_3_active.51479615.png";